import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Young garden tree ~1.8 m: a slim trunk, two small leaf clumps and a soil
// disc at the base — the freshly planted counterpart of garden-tree.
const BARK = "#6b4a2a";
const LEAF = "#5f8f4e";
const LEAF_DARK = "#4e7a3e";
const SOIL = "#5a4632";

export const gardenTreeSmall = defineModel({
  id: "garden-tree-small",
  batchId: "modern",
  name: "Small garden tree",
  tags: ["modern", "outdoor", "garden", "tree", "plant", "sapling"],
  summary: "A young garden tree about 1.8 metres tall on a soil disc.",
  description:
    "A freshly planted young tree of the Modern Living kit: ~1.8 m tall, a " +
    "slim bark trunk with two small leaf clumps and a soil disc at the base. " +
    "Fits a single garden tile.",
  tiles: { w: 1, h: 1 },
  footprint: 1.0,
  parts(): Part[] {
    return [
      // Soil disc at the base.
      {
        geometry: new THREE.CylinderGeometry(0.22, 0.24, 0.04, 8),
        color: SOIL,
        position: [0, 0.02, 0],
      },
      {
        geometry: new THREE.CylinderGeometry(0.045, 0.075, 0.95, 7),
        color: BARK,
        position: [0, 0.475, 0],
      },
      { geometry: new THREE.IcosahedronGeometry(0.42, 0), color: LEAF, position: [0, 1.3, 0] },
      {
        geometry: new THREE.IcosahedronGeometry(0.26, 0),
        color: LEAF_DARK,
        position: [0.17, 1.56, 0.1],
      },
    ];
  },
  animations: [],
});
